"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHaemostaseology = createHaemostaseology;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const haemostaseology_1 = require("../../../forms/ktx/transplantation-screening/medical-history/haemostaseology");
const messages = {
    title: {
        id: "ktx.dashboard.haemostaseology",
        defaultMessage: "Thromboembolia"
    }
};
function createHaemostaseology(intl, options) {
    const lists = createList(intl, options);
    const content = (0, shared_1.createGroupContent)(lists);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createList({ formatMessageMap, formatDate }, { events }) {
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.haemostaseologyType);
    const m = { ...haemostaseology_1.haemostaseologyTypeMessages, ...haemostaseology_1.hasDiseaseMessages };
    return relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        let formattedMessage;
        const inc = Object.keys(m).includes(event.value);
        if (!inc) {
            formattedMessage = event.value;
        }
        else {
            formattedMessage = formatMessageMap(m, event.value);
        }
        const items = [];
        items.push({
            type: "list-item",
            value: formattedMessage
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
}
